export const SortableContainerCSSClass = 'sortable-container';
export const SortableRowCSSClass = 'sortable-row';
export const SortableRowDropzoneCSSClass = 'dropzone';
export const DragHelperCSSClass = 'drag-helper';
export const DragPlaceholderCSSClass = 'drag-placeholder';
export const DragActiveCSSClass = 'drag-active';
export const DragActiveEntryCSSClass = 'active-drag-entry';

// Attributes
export const SortableRowItemIdAttribute = 'data-item-id';
export const SortedIndexAttribute = 'data-sorted-index';
export const PosYAttribute = 'data-pos-y';
export const GapAttribute = 'data-gap';
